// Per-question details tiles, stats tiles, and Most Voted Responses table.

import React from "react";
import { Typography } from "@material-tailwind/react";
import {
    GobbyTable,
    GobbyTableHead,
    GobbyTableBody,
    GobbyTableRow,
    GobbyTableHeader,
    GobbyTableCell,
} from "components/ui/gobby-table";
import { formatBoolean } from "../data-transforms";

export function QuestionBreakdown({ qData }) {
    return (
        <>
            {/* Question Title */}
            <Typography variant="h5" className="mb-1 text-primary">
                Q{qData.number}: {qData.text}
            </Typography>

            {/* Question Details */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">Type</Typography>
                    <Typography className="text-black">{qData.type || "N/A"}</Typography>
                </div>
                {(qData.type === "Preset" || qData.type === "Mixed") && (
                    <div className="bg-platinumlight p-4 rounded-lg">
                        <Typography className="font-semibold text-black">Number of Presets</Typography>
                        <Typography className="text-black">{qData.numPresets ?? "N/A"}</Typography>
                    </div>
                )}
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">Response Type</Typography>
                    <Typography className="text-black">{qData.responseType || "N/A"}</Typography>
                </div>
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">Demographic</Typography>
                    <Typography className="text-black">
                        {qData.demographic !== undefined ? formatBoolean(qData.demographic) : "N/A"}
                    </Typography>
                </div>
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">PII</Typography>
                    <Typography className="text-black">
                        {qData.pii !== undefined ? formatBoolean(qData.pii) : "N/A"}
                    </Typography>
                </div>
            </div>

            {/* Question Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                {qData.type === "Gobby" && (
                    <div className="bg-platinumlight p-4 rounded-lg">
                        <Typography className="font-semibold text-black">Contributors</Typography>
                        <Typography className="text-black">{qData.contributors ?? "N/A"}</Typography>
                    </div>
                )}
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">Responses</Typography>
                    <Typography className="text-black">{qData.responses ?? "N/A"}</Typography>
                </div>
                {qData.type === "Gobby" && (
                    <div className="bg-platinumlight p-4 rounded-lg">
                        <Typography className="font-semibold text-black">Unique Responses</Typography>
                        <Typography className="text-black">{qData.uniqueResponses ?? "N/A"}</Typography>
                    </div>
                )}
                {qData.type === "Gobby" && (
                    <>
                        <div className="bg-platinumlight p-4 rounded-lg">
                            <Typography className="font-semibold text-black">Matched Responses</Typography>
                            <Typography className="text-black">{qData.votes ?? "N/A"}</Typography>
                        </div><div className="bg-platinumlight p-4 rounded-lg">
                            <Typography className="font-semibold text-black">Unthemed</Typography>
                            <Typography className="text-black">{qData.unthemed ?? "N/A"}</Typography>
                        </div>
                    </>
                )}
                {qData.type === "Gobby" && (
                    <div className="bg-platinumlight p-4 rounded-lg">
                        <Typography className="font-semibold text-black">Moderated</Typography>
                        <Typography className="text-black">{qData.moderated ?? "N/A"}</Typography>
                    </div>
                )}
            </div>

            {/* Most Voted Responses */}
            {qData.type === "Gobby" && (
                <div className="mb-4">
                    <Typography variant="h5" className="mb-2">The top responses matched were:</Typography>
                    <GobbyTable>
                        <GobbyTableHead>
                            <GobbyTableRow>
                                <GobbyTableHeader>Rank</GobbyTableHeader>
                                <GobbyTableHeader>Response text</GobbyTableHeader>
                                <GobbyTableHeader>Matched Responses</GobbyTableHeader>
                            </GobbyTableRow>
                        </GobbyTableHead>
                        <GobbyTableBody>
                            {(qData.mostVoted || []).map((response, index) => (
                                <GobbyTableRow key={index}>
                                    <GobbyTableCell>{index + 1}</GobbyTableCell>
                                    <GobbyTableCell>{response.text}</GobbyTableCell>
                                    <GobbyTableCell>{response.votes}</GobbyTableCell>
                                </GobbyTableRow>
                            ))}
                        </GobbyTableBody>
                    </GobbyTable>
                </div>
            )}
        </>
    );
}
